import {
  Breakpoints,
  BreakpointWrapper,
} from '@volkswagen-onehub/components-core';
import React from 'react';

export const CTAsSiNo = [
  { label: 'Sí', value: 'true' },
  { label: 'No', value: 'false' },
];

export const contactoOptionsTurismos = [
  {
    value: 'Email',
    label: 'Email',
  },
  {
    value: 'Teléfono',
    label: 'Teléfono',
  },
  {
    value: 'Videollamada',
    label: 'Videollamada',
  },
];

export const contactoOptionsComerciales = [
  {
    value: 'Teléfono',
    label: 'Teléfono',
  },
  {
    value: 'Email',
    label: 'Email',
  },
];
export const CTAsHorario = [
  { label: 'Por la mañana', value: 'morning' },
  { label: 'Al mediodía', value: 'afternon' },
  { label: 'Por la tarde', value: 'evening' },
];

//Cita posventa

export interface CTAsMotivoDef {
  label: string;
  value: string;
  detalles?: string | JSX.Element;
  detallesPrevStep?: string;
}

export const CTAsMotivo: CTAsMotivoDef[] = [
  {
    label: 'Mantenimiento',
    value: 'MANTENIMIENTO',
    detalles: 'la revisión de mantenimiento',
    detallesPrevStep: 'Revisión de mantenimiento',
  },
  {
    label: 'Neumáticos',
    value: 'NEUMATICOS',
    detalles: 'el cambio de neumáticos',
    detallesPrevStep: 'Cambio de neumáticos',
  },
  { label: 'Avería', value: 'REPARACION', detalles: 'la avería', detallesPrevStep: 'Reparación de avería' },
  {
    label: 'Revisión pre-ITV',
    value: 'PREITV',
    detalles: (
      <>
        la revisión{' '}
        <BreakpointWrapper min={Breakpoints.b960}>
          <br />
        </BreakpointWrapper>
        pre-ITV
      </>
    ),
    detallesPrevStep: 'Revisión pre-ITV',
  },
  {
    label: 'Chapa y pintura',
    value: 'CARROCERIA',
    detalles: 'la reparación de chapa y pintura',
    detallesPrevStep: 'Reparación de chapa y pintura',
  },
  {
    label: 'Accesorios',
    value: 'ACCESORIOS',
    detalles: 'la instalación de los accesorios',
    detallesPrevStep: 'Instalación de accesorios',
  },
  // { label: 'Chequeo', value: 'CHEQUEO', detalles: 'el chequeo de tu coche', detallesPrevStep: 'Chequeo' },
  {
    label: 'Actualización Software ID',
    value: 'OTROS', 
    detalles: 'Actualización Software ID', 
    detallesPrevStep: 'Actualización Software ID'
  },
  {
    label: 'Otros',
    value: 'OTROS', 
    detalles: 'el motivo de tu visita', 
    detallesPrevStep: 'Visita'
  },
];

// LEM

export const CTAsTipoVisita = [
  {
    label: 'Una visita al concesionario',
    value: 'si visita',
  },
  {
    label: 'Una llamada',
    value: 'si llamada'
  },
  {
    label: 'Una videollamada',
    value: 'si videollamada'
  },
];

export const CTAsTipoVisitaNo = [
  {
    label: 'No ha hecho falta',
    value: 'no ha hecho falta',
  },
  {
    label: 'No, pero me hubiera gustado',
    value: 'no pero me hubiera gustado',
  },
];

export const periodoContactoOptions = [
  {
    value: '8_horas',
    label: 'En las primeras 8 horas',
  },
  {
    value: '24_horas',
    label: 'En las primeras 24 horas',
  },
  {
    value: 'mas_24_horas',
    label: 'En más de 24 horas',
  },
];

//No compra

export const CTAsMotivoNoQuiero = [
  {
    label: 'Coche compartido (car sharing o moto sharing)',
    value: 'car-sharing',
  },
  {
    label: 'Transporte público',
    value: 'transporte-publico',
  },
  {
    label: 'Patinete - Moto - Bicicleta',
    value: 'patinete-moto-bicicleta',
  },
  {
    label: 'Más adelante, en coche',
    value: 'coche',
  },
  {
    label: 'Otros',
    value: 'otros',
  },
];

export const CTAsDudas = [
  { label: 'Los plazos de entrega', value: 'plazos' },
  { label: 'Tu visita al concesionario', value: 'experiencia' },
  { label: 'El precio del modelo', value: 'precio' },
  { label: 'El equipamiento y los asistentes adicionales', value: 'equipamiento' },
  { label: 'El consumo del modelo', value: 'consumo' },
  { label: 'La garantía del modelo', value: 'garantia' },
  { label: 'Las condiciones de financiación', value: 'financiación' },
  { label: 'La situación actual', value: 'situacion' },
  { label: 'Otros motivos', value: 'otros' },
];

//SAC

export const contactoOptionsSAC = [
  {
    value: 'EMAIL',
    label: 'Email',
  },
  {
    value: 'TELF',
    label: 'Teléfono',
  },
  // {
  //   value: 'POSTAL',
  //   label: 'Correo postal',
  // },
  {
    value: 'WHATSAPP',
    label: 'Whatsapp',
  },
];

//CEM postenta y CEM venta

export const ctaTestDrive = [
  { label: 'Sí y realicé la prueba', value: '1' },
  { label: 'Sí, pero no realicé la prueba', value: '2' },
  { label: 'No, pero estaba interesado/a ', value: '3' },
  { label: 'No y no estaba interesado/a', value: '4' },
];

export const ctaDatosIncorrectos = [
  { label: 'Marca incorrecta', value: 'Marca' },
  { label: 'Modelo incorrecto', value: 'Modelo' },
  { label: 'Concesionario incorrecto', value: 'Instalación' },
  { label: 'Persona de contacto incorrecta', value: 'Contacto' },
];

export const ctaDatosIncorrectosPosventa = [
  { label: 'Marca incorrecta', value: 'Marca' },
  { label: 'Modelo incorrecto', value: 'Modelo' },
  { label: 'Servicio Oficial', value: 'Instalación' },
  { label: 'Persona de contacto incorrecta', value: 'Contacto' },
];


export const ctaAlternativaTransporte = [
  { label: 'Sí, un Volkswagen', value: '1' },
  { label: 'Sí, un coche de otra marca diferente a Volkswagen', value: '2' },
  { label: 'Sí, otra alternativa (transporte público, taxi, shuttle, …)', value: '3' },
  { label: 'No me ofreció ninguna', value: '4' },
  { label: 'Sin respuesta', value: '9' },
];
export const ctaContactoSatisfaccion = [
  { label: 'Sí', value: '1' },
  { label: 'No', value: '2' },
  { label: 'Sin respuesta', value: '9' },
];

export const ctaTrabajosAdicionales = [
  {label: 'Sí, he sido bien informado directamente junto al coche', value: '1'},
  {label: 'Sí, he sido bien informado directamente por vídeo', value: '2'},
  {label: 'No hubo recepción directamente junto al coche o por vídeo', value: '3'},
  {label: 'No, no me sentí bien informado', value: '4'},
  {label: 'No fue posible por ejemplo, debido a un accidente', value: '5'},
  {label: 'Sin respuesta', value: '9'},
]

export const ctaMotivoVisita = [

  { label: 'Revisión pre-ITV', value: '2' },
  { label: 'Avería circulando con el coche (fue necesario remolcarlo)', value: '4' },
  { label: 'Medida de servicio (excluida la medida de servicio diésel)', value: '10' },
  { label: 'Chapa y pintura', value: '6' },
  { label: 'Cambio de neumáticos', value: '3' },
  { label: 'Actualización de software', value: '11' },
  { label: 'Instalación de accesorios', value: '7' },
  { label: 'Servicio rutinario / de mantenimiento', value: '1' },
  { label: 'Otra visita inesperada (el coche pudo seguir circulando y elegiste tu Sercicio Oficial favorito)', value: '5' },
  { label: 'Otras reparaciones  o reclamaciones (por ejemplo, problemas electrónicos)', value: '8' },
  { label: 'Sin respuesta', value: '99' },
];

export const ctaEnviarRespuesta = [
  { label: 'Mis respuestas pueden ser enviadas junto a mi nombre', value: '1' },
  {
    label: 'Mis respuestas pueden ser enviadas pero sin mencionar mi nombre',
    extraInfo:
      'Seleccionando esta opción, el concesionario no podrá ponerse en contacto contigo en relación a tus comentarios.',
    value: '2',
  },
  {
    label: 'Mis respuestas solo deben ser analizadas de manera anónima',
    extraInfo:
      'Seleccionando esta opción, tus respuestas serán analizadas de modo agregado junto al resto de respuestas de todos los entrevistados y no se trasladarán a los comentarios abiertos.',
    value: '0',
  },
];
export const ctaEnvioCEM = [
  {
    label:
      'Sí, mis respuestas pueden ser publicadas de forma agregada sin mi nombre en la Web Oficial Volkswagen y en la de [Concesionario]',
    value: '1',
  },
  {
    label:
      'No, mis respuestas no pueden ser publicadas de forma agregada en la Web Oficial Volkswagen y en la de [Concesionario]',
    value: '2',
  },
];

// CEM ONESHOP

export const ctaPruebaTCross = [
  { label: 'Sí', value: 'true' },
  { label: 'No', value: 'false' },
  { label: 'No, pero me lo ofrecieron', value: 'No, pero me lo ofrecieron' },
]

// No renovador

export const CTAsMotor = [
  {
    label: 'Gasolina',
    value: 'gasolina',
  },
  {
    label: 'Diesel',
    value: 'diesel',
  },
  {
    label: 'Híbrido',
    value: 'híbrido',
  },
  {
    label: 'Eléctrico',
    value: 'electrico',
  },
];
export const CTAsMotivoRenovadorYaTengo = [
  {
    label: 'Los plazos de entrega',
    value: 'plazos',
  },
  {
    label: 'El precio',
    value: 'precio',
  },
  {
    label: 'Las opciones de financiación',
    value: 'financiacion',
  },
  {
    label: 'El diseño del coche',
    value: 'diseño',
  },
  {
    label: 'El equipamiento del coche',
    value: 'equipamiento',
  },
  {
    label: 'Relación calidad/precio',
    value: 'relación calidad/precio',
  },
  {
    label: 'El consumo de combustible de los nuevos vehículos',
    value: 'consumo',
  },
  {
    label: 'La poca variedad de modelos y tecnologías disponibles',
    value: 'modelos',
  },
  {
    label: 'Mi experiencia con el concesionario de venta',
    value: 'experiencia venta',
  },
  {
    label: 'Mi experiencia previa con el servicio de posventa',
    value: 'experiencia posventa',
  },
  {
    label: 'Los costes de mantenimiento del vehículo anterior',
    value: 'costes mantenimiento',
  },
  {
    label: 'Las averías sufridas con el vehículo anterior',
    value: 'averías',
  },
  {
    label: 'Otras experiencias con la marca',
    value: 'marca',
  },
  {
    label: 'Otros motivos',
    value: 'otros motivos',
  },
];

export const CTAsMotivoRenovadorNoTengo = [
  {
    label: 'Los plazos de entrega',
    value: 'plazos',
  },
  {
    label: 'El precio',
    value: 'precio',
  },
  {
    label: 'Las opciones de financiación',
    value: 'financiacion',
  },
  {
    label: 'El diseño del coche',
    value: 'diseño',
  },
  {
    label: 'El equipamiento del coche',
    value: 'equipamiento',
  },
  {
    label: 'Relación calidad/precio',
    value: 'relación calidad/precio',
  },
  {
    label: 'El consumo de combustible de los nuevos vehículos',
    value: 'consumo',
  },
  {
    label: 'La poca variedad de modelos y tecnologías disponibles',
    value: 'modelos',
  },
  {
    label: 'Mi experiencia con el concesionario de venta',
    value: 'experiencia venta',
  },
  {
    label: 'Mi experiencia previa con el servicio de posventa',
    value: 'experiencia posventa',
  },
  {
    label: 'Los costes de mantenimiento del vehículo anterior',
    value: 'costes mantenimiento',
  },
  {
    label: 'Las averías sufridas con el vehículo anterior',
    value: 'averías',
  },
  {
    label: 'Otras experiencias con la marca',
    value: 'marca',
  },
  {
    label: 'Otros motivos',
    value: 'otros motivos',
  },
];

export const CTAsMotivoRenovadorNoTengoExclusivo = [
  {
    label: 'Nada',
    value: 'nada',
  },
];

export const CTAsUsadoNuevo = [
  {
    label: 'Vehículo Nuevo',
    value: 'Vehículo Nuevo',
  },
  {
    label: 'Vehículo Usado',
    value: 'Vehículo Usado',
  },
];

export const CTAsLugarCompra = [
  {
    label: 'Concesionario oficial',
    value: 'Concesionario oficial',
  },
  {
    label: 'Concesionario no oficial',
    value: 'Concesionario no oficial',
  },
  {
    label: 'Empresa de Renting/Leasing',
    value: 'Empresa de Renting/Leasing',
  },
  {
    label: 'Compra-venta privada',
    value: 'Compra-venta privada',
  },
];

export const CTAsNuevoOcasión = [
  {
    label: 'Uno nuevo',
    value: 'nuevo',
  },
  {
    label: 'Uno de ocasión',
    value: 'ocasión',
  },
];

export const CTAsFormasMovilidad = [
  {
    label: 'Coche compartido (car sharing o moto sharing)',
    value: 'Car Sharing Moto Sharing',
  },
  {
    label: 'Transporte público',
    value: 'Transporte público',
  },
  {
    label: 'Patinete',
    value: 'Patinete',
  },
  {
    label: 'Moto',
    value: 'Moto',
  },
  {
    label: 'Bicicleta',
    value: 'Bicicleta',
  },
  {
    label: 'Otros',
    value: 'Otros',
  },
];
export const CTAsFormasMovilidadExclusive = [
  {
    label: 'No tengo necesidad de utilizar ningún medio de transporte para desplazarme',
    value: 'No tengo necesidad',
  },
];
export const CTAsRazones = [
  {
    label: 'Económicas',
    value: 'Económicas',
  },
  {
    label: 'Medioambientales',
    value: 'Medioambientales',
  },
  {
    label: 'Ahorro de tiempo',
    value: 'Ahorro de tiempo',
  },
  {
    label: 'Otras razones',
    value: 'Otros',
  },
];

//BAJA COMUNICACIONES

export const questionTwoOptions = [
  {
    label: 'Ya no me interesa el contenido',
    value: 'No Interés'
  },
  {
    label: 'Recibo demasiadas comunicaciones vuestras',
    value: 'Demasiadas Comunicaciones'
  },
  {
    label: 'Tengo otras razones',
    value: 'Otros Motivos'
  },
];
